import { render, staticRenderFns } from "./QuoteAttachmentCategory.vue?vue&type=template&id=6c4e75d1"
import script from "./QuoteAttachmentCategory.vue?vue&type=script&lang=js"
export * from "./QuoteAttachmentCategory.vue?vue&type=script&lang=js"
import style0 from "./QuoteAttachmentCategory.vue?vue&type=style&index=0&id=6c4e75d1&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c4e75d1')) {
      api.createRecord('6c4e75d1', component.options)
    } else {
      api.reload('6c4e75d1', component.options)
    }
    module.hot.accept("./QuoteAttachmentCategory.vue?vue&type=template&id=6c4e75d1", function () {
      api.rerender('6c4e75d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteAttachmentCategory.vue"
export default component.exports